export default __webpack_public_path__ + "static/25-49e0df8e43be209e1e93769839b5a83d.svg";